import { DateTime } from 'luxon';
import { AbstractViewModel } from '../../../abstract.view.model';
import { CardApiModel } from '../../../api-model/account-items/card/card.api.model';
import { CardTypeViewModel } from '../../card/card-type.view.model';
import { UserCardViewModel } from '../../user-history/card/user-card.view.model';
import { CardPointsToExpireViewModel } from './card-points-to-expire.view.model';

export class CardViewModel extends AbstractViewModel<CardApiModel> {
  public id: string;
  public cardTypeId: string;
  public name: string;
  public description: string;
  public message: string;
  public picture: string;
  public number: string;
  public flgSubscription: boolean;
  public type: number;
  public valueBalance: number;
  public pointsBalance: number;
  public expiryDate: DateTime;
  public typeDescriptions: string[] = [];
  public collectedPoints: number;

  public batchName: string;

  public cardType: CardTypeViewModel;
  public isUsed = false;
  public pointsToExpire: CardPointsToExpireViewModel[] = [];

  constructor(protected apiModel: CardApiModel = new CardApiModel()) {
    super(apiModel);
    this.fromApiModel();
  }

  protected fromApiModel(): void {
    this.id = this.apiModel.id;
    this.cardTypeId = this.apiModel.cardTypeId;
    this.name = this.apiModel.name;
    this.batchName = this.apiModel.batchName;
    this.description = this.apiModel.description;
    this.message = this.apiModel.message;
    this.picture = this.apiModel.picture;
    this.number = this.apiModel.number;
    this.flgSubscription = this.apiModel.flgSubscription;
    this.type = this.apiModel.type;
    this.valueBalance = this.apiModel.valueBalance;
    this.pointsBalance = this.apiModel.pointsBalance;
    this.expiryDate = this.apiModel.expiryDate ? DateTime.fromISO(this.apiModel.expiryDate) : null;
    this.typeDescriptions = this.apiModel.typeDescriptions;
    this.collectedPoints = this.apiModel.collectedPoints;
    this.pointsToExpire = this.apiModel.pointsToExpire
      ? this.apiModel.pointsToExpire.map((pointToExpire) => new CardPointsToExpireViewModel(pointToExpire))
      : [];
  }

  toApiModel(): CardApiModel {
    return undefined;
  }

  toUserCardViewModel(extra?: UserCardViewModel): UserCardViewModel {
    const model = Object.assign(extra ?? new UserCardViewModel(), {
      id: this.id,
      number: this.number,
      name: this.name,
      batchName: this.batchName,
      description: this.description,
      typeId: this.cardTypeId,
      type: this.type,
      valueBalance: this.valueBalance,
      pointBalance: this.pointsBalance,
      expiryDate: this.expiryDate,
      cardType: this.cardType?.toUserCardTypeViewModel(),
      picture: this.picture,
      isUsed: this.isUsed
    });

    return model;
  }

  get batchNameOrDefault() {
    return this.batchName ?? this.name;
  }

  get nextPointsExpiryDate() {
    return this.pointsToExpire?.length ? this.pointsToExpire[0].expiryDate : null;
  }

  get nextPointsToExpire() {
    return this.pointsToExpire?.length ? this.pointsToExpire[0].points : 0;
  }
}
